import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps } from "vue"
import _imports_0 from '../../../assets/zt_zanwushuju.png'


const _hoisted_1 = {
  key: 0,
  style: {"width":"60%","margin":"0 auto","display":"block"},
  class: "zanwushuju",
  src: _imports_0
}
const _hoisted_2 = { style: {"padding-top":"0.3rem"} }
const _hoisted_3 = { style: {"margin-top":"0.4rem","margin-bottom":"0.6rem"} }

import { ref, onMounted, watch, onBeforeUnmount } from "vue";
import { useRouter, RouteLocationNormalizedLoaded, useRoute } from "vue-router";
import dropDown from "../../../components/comTemplate/drop-down.vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import wavesurfer from "@/components/Wavesurfer/index.vue";
// import ShadowMaterialyinyue from "../ShadowMaterialyinyue.vue";
import { ElMessage, ElLoading } from "element-plus";

import moduleProvideMaterialMusic from "../../../components/moduleProvideMaterialMusic.vue";
import { log } from "node:console";
const loading = null;

export default /*@__PURE__*/_defineComponent({
  __name: 'musicAll',
  props: {
  route_query: Object,
},
  setup(__props) {

const route = useRoute();
document.title = "标识山西-找素材-音乐素材";
const props = __props;

// 音乐播放
const isChildVisible = ref(false);
const moduleProvideMaterialMusicRef = ref();
let num = 0;
const ShadowMaterialyinyueRef = ref();
const MusicOff = (id) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (id == e.newData.message.id) {
      e.sendValue2();
    }
  });
};
const MusicOn = (id) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (id == e.newData.message.id) {
      e.sendValue3();
    }
  });
};
const bovalue = ref("");
const yinyuelist = ref(null);
const keyword = ref("");
watch(
  () => route.query.keyword,
  (newData, oldData) => {
    if (newData != oldData) {
      keyword.value = newData;

      init_VIDEO();
    }
  },
  {
    immediate: false,
    deep: true,
  }
);
const handleCallback = async (audio: any) => {
  //   if (bgType.value != 3) return;
  if (!isChildVisible.value) {
    isChildVisible.value = true;
  }
  let isSee = true;
  const musicRef = moduleProvideMaterialMusicRef.value.find(
    (x) => x.newData.message.id === audio.id
  );
  if (!musicRef.runningStatus) {
    ShadowMaterialyinyueRef.value.handleStop();
    isSee = false;
  } else if (musicRef.runningStatus && audio.id === bovalue.value.id) {
    ShadowMaterialyinyueRef.value.playAudio();
  }
  bovalue.value = audio;
  if (isSee) {
    let show = await getPaymentRequest(audio.id);
    if (show) {
      nums2(audio);
    }
  }
};
const nums2 = (audio: any) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (audio.id == e.newData.message.id) {
      e.numS1();
    }
  });
};
const getPaymentRequest = async (materialId) => {
  return new Promise(async (resolve, reject) => {
    await Axios(
      "post",
      "/fodder/member-visited",
      {
        materialId: materialId,
      },
      false,
      (res) => {
        resolve(true);
      }
    );
  });
};
let pageDef = ref({
  pageNum: 1,
  pageSize: 20,
  total: 0,
});
const page = pageDef;

let paramIndex = ref("");
let fileExt = ref("");
let widthHeightRate = ref("");
let typeIds = ref("");
let resolutionRate = ref("");
let startTime = ref("");
//音频
const boxRef = ref({
  left: [
    {
      name: "用途",
      value: "1",
      listShow: true,
      list: [
        {
          name: "用途",
          value: "1-1",
        },
      ],
    },
    {
      name: "情绪",
      value: "2",
      listShow: true,
      list: [
        {
          name: "情绪",
          value: "2-1",
        },
      ],
    },
    {
      name: "风格",
      value: "3",
      listShow: true,
      list: [
        {
          name: "风格",
          value: "3-1",
        },
      ],
    },
    {
      name: "乐器",
      value: "4",
      listShow: true,
      list: [
        {
          name: "乐曲",
          value: "4-1",
        },
      ],
    },
  ],
  center: [
    {
      name: "价格",
      value: "5",
      listShow: true,
      width: "2.8rem",
      list: [
        {
          name: "全部",
          value: "",
          newName: "价格",
        },
        {
          name: "免费素材",
          value: [0, 0],
        },
        {
          name: "≤50元",
          value: [0, 50],
        },
        {
          name: "50-200元",
          value: [50, 200],
        },
        {
          name: "200-800元",
          value: [200, 800],
        },
        {
          name: "800元以上",
          value: [800],
        },
      ],
    },
    {
      name: "时长",
      value: "6",
      listShow: true,
      list: [
        {
          name: "全部",
          value: "",
          newName: "时长",
        },
        {
          name: "1分钟以下",
          value: [0, 1],
        },
        {
          name: "1-3分钟",
          value: [1, 3],
        },
        {
          name: "3-5分钟",
          value: [3, 5],
        },
        {
          name: "5分钟以上",
          value: [5],
        },
      ],
    },
    {
      name: "节拍",
      value: "7",
      listShow: true,
      width: "2.8rem",
      list: [
        {
          name: "全部",
          value: "",
          newName: "节拍",
        },
        {
          name: "0-45",
          value: [0, 45],
        },
        {
          name: "45-63",
          value: [45, 63],
        },
        {
          name: "63-78",
          value: [63, 78],
        },
        {
          name: "78-95",
          value: [78, 95],
        },
        {
          name: "95-130",
          value: [95, 130],
        },
        {
          name: "130-160",
          value: [130, 160],
        },
        {
          name: "160+",
          value: [160],
        },
      ],
    },
  ],
  right: [
    {
      name: "默认排序",
      value: "9",
      listShow: true,
      list: [
        {
          name: "默认排序",
          value: "0",
        },
        {
          name: "最多下载",
          value: "1",
        },
        {
          name: "最新上传",
          value: "3",
        },
      ],
    },
  ],
});
let newTypeIdsValue1 = ref("");
let newTypeIdsValue2 = ref("");
let newTypeIdsValue3 = ref("");
let newTypeIdsValue4 = ref("");
let newTypeIdsValue5 = ref([]);
let newTypeIdsValue6 = ref([]);
let newTypeIdsValue7 = ref([]);
let newTypeIdsValue9 = ref("");

const tabClick = (value, value2, item, item2, index, index_) => {
  console.log("=======================");

  // console.log(item2.value)

  console.log(value, value2, item, item2, index, index_, "点击子组件");
  if (value == 1 && item2) {
    if (item2.newName) {
      boxRef.value.left[index].name = item2.newName;
      newTypeIdsValue1.value = "";
    } else {
      boxRef.value.left[index].name = item2.name;
      newTypeIdsValue1.value = item2.value;
    }
  }
  if (value == 2 && item2) {
    if (item2.newName) {
      boxRef.value.left[index].name = item2.newName;
      newTypeIdsValue2.value = "";
    } else {
      boxRef.value.left[index].name = item2.name;
      newTypeIdsValue2.value = item2.value;
    }
  }
  if (value == 3 && item2) {
    if (item2.newName) {
      boxRef.value.left[index].name = item2.newName;
      newTypeIdsValue3.value = "";
    } else {
      boxRef.value.left[index].name = item2.name;
      newTypeIdsValue3.value = item2.value;
    }
  }
  if (value == 4 && item2) {
    if (item2.newName) {
      boxRef.value.left[index].name = item2.newName;
      newTypeIdsValue4.value = "";
    } else {
      boxRef.value.left[index].name = item2.name;
      newTypeIdsValue4.value = item2.value;
    }
  }
  let list = [];
  if (newTypeIdsValue1.value != "") {
    list.push(newTypeIdsValue1.value);
  }
  if (newTypeIdsValue2.value != "") {
    list.push(newTypeIdsValue2.value);
  }
  if (newTypeIdsValue3.value != "") {
    list.push(newTypeIdsValue3.value);
  }
  if (newTypeIdsValue4.value != "") {
    list.push(newTypeIdsValue4.value);
  }
  typeIds.value = list.join(",");
  //中间数据
  if (value == 5 && item2) {
    if (item2.newName) {
      boxRef.value.center[index].name = item2.newName;
      newTypeIdsValue5.value = "";
    } else {
      boxRef.value.center[index].name = item2.name;
      newTypeIdsValue5.value = item2.value;
    }
  }
  if (value == 6 && item2) {
    if (item2.newName) {
      boxRef.value.center[index].name = item2.newName;
      newTypeIdsValue6.value = "";
    } else {
      boxRef.value.center[index].name = item2.name;
      newTypeIdsValue6.value = item2.value;
    }
  }
  if (value == 7 && item2) {
    if (item2.newName) {
      boxRef.value.center[index].name = item2.newName;
      newTypeIdsValue7.value = "";
    } else {
      boxRef.value.center[index].name = item2.name;
      newTypeIdsValue7.value = item2.value;
    }
  }
  //右边
  // if (value == 9 && item2) {
  //   if (item2.newName) {
  //     boxRef.value.left[index].name = item2.newName;
  //     newTypeIdsValue9.value = "";
  //   } else {
  //     boxRef.value.left[index].name = item2.name;
  //     newTypeIdsValue9.value = item2.value;
  //   }
  // }
  if (value == 9 && item2) {
    boxRef.value.right[index].name = item2.name;
    paramIndex.value = item2.value;
  }

  init_VIDEO();
};
const modifyJSON = (data) => {
  let arr = [];

  data.forEach((e) => {
    if (e.isTop === "1") {
      if (e.options) {
        if (e.options.length) {
          e.arr = [];
          e.options.forEach((ie) => {
            if (ie.options) {
              if (ie.options.length) {
                ie.options.forEach((item) => {
                  if (item.isTop === "1") {
                    item.checked = false;
                    item.value = item.id;
                    e.arr.push(item);
                  }
                });
              }
            }
          });
        }
      }
    }
  });
  console.log("data", data);

  data.forEach((e) => {
    let obj = {};
    obj.id = e.id;
    obj.createUser = e.createUser;
    obj.isTop = e.isTop;
    obj.name = e.name;
    obj.parentId = e.parentId;
    obj.updateTime = e.updateTime;
    e.arr.unshift(
      {
        name: "全部",
        value: "",
        newName: e.name,
      },
      {
        name: e.name,
        value: e.id,
        materialType: e.materialType,
        params: null,
        parentId: e.updateTime,
        status: "0",
        typeSort: 0,
        updateTime: e.updateTime,
        updateUser: null,
        // newName: item.name,
      }
    );
    obj.list = e.arr;
    obj.value = e.id;
    obj.checked = false;
    arr.push(obj);
  });
  return arr;
};
// 假设data是包含所有数据的数组
function findTopItems(data) {
  const tree = {};

  for (const material of data) {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = {
        ...material,
        options: [],
      };
    } else {
      tree[id] = {
        ...material,
        options: tree[id].options,
      };
    }

    if (!tree[parentId]) {
      tree[parentId] = {
        options: [],
      };
    }
    tree[id].checked = false;
    tree[parentId].options.push(tree[id]);
  }

  // 找到根节点并返回
  const roots = Object.values(tree).filter((node) => !node.parentId);
  return roots;
}
// 视频分类
Axios("get", "/fodder/music-types", {}, false, function (res) {
  videoList.value = [];

  let topItems = findTopItems(res.data.data);
  topItems.shift();

  const refactoredData = modifyJSON(topItems);
  const tree = refactoredData;
  console.log("treetreetreetreetreetreetreetreetree", tree);
  tree[0].listShow = true;
  tree[0].value = 1;
  boxRef.value.left[0] = tree[0];
  tree[1].value = 2;
  tree[1].listShow = true;
  boxRef.value.left[1] = tree[1];
  tree[2].listShow = true;
  tree[2].value = 3;
  boxRef.value.left[2] = tree[2];
  tree[3].listShow = true;
  tree[3].value = 4;
  boxRef.value.left[3] = tree[3];

  if (props.route_query.typeIds) {
    typeIds.value = props.route_query.typeIds;
    boxRef.value.left[props.route_query.index].name =
      props.route_query.typeIdsName;
  }
});
function buildTree(materials) {
  const tree = {};

  materials.forEach((material) => {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = {
        ...material,
        list: [],
      };
    } else {
      tree[id] = {
        ...material,
        list: tree[id].list,
      };
    }

    if (!tree[parentId]) {
      tree[parentId] = {
        list: [],
      };
    }
    tree[id].checked = false;
    tree[parentId].list.push(tree[id]);
  });
  tree[0].list.forEach((item, index) => {
    item.list.unshift({
      name: "全部",
      value: "",
      newName: item.name,
    });
  });
  return tree[0].list;
}

const videoList = ref([]);
let num1 = 0;
const init_VIDEO = (value1, value2) => {
  loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  num1++;
  let typeIds1 = "";
  if (num1 == 1) {
    if (route.query.typeIds) {
      typeIds1 = route.query.typeIds;
    }
  } else {
    var hasComma = typeIds.value.includes(",");

    if (hasComma) {
      typeIds1 = typeIds.value;
    } else {
      typeIds1 = typeIds.value;
    }
  }
  let params = {
    isOnline: 0,
    materialType: "MUSIC",
    paramIndex: paramIndex.value, //(排序方式（0默认1最新2热门）)
    status: 1,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    typeIds: typeIds1,
    keyword: keyword.value,
    // fileExt: fileExt.value,
    startTime: startTime.value,
    resolutionRate: resolutionRate.value,
    widthHeightRate: widthHeightRate.value,
  };
  //时长
  if (newTypeIdsValue6.value.length != 0) {
    if (newTypeIdsValue6.value.length == 2) {
      params["startTime"] = newTypeIdsValue6.value[0];
      params["endTime"] = newTypeIdsValue6.value[1];
    } else {
      params["startTime"] = newTypeIdsValue6.value[0];
    }
  }
  //节拍 分辨率
  if (newTypeIdsValue7.value.length != 0) {
    if (newTypeIdsValue7.value.length == 2) {
      params["startBpm"] = newTypeIdsValue7.value[0];
      params["endtBpm"] = newTypeIdsValue7.value[1];
    } else {
      params["startBpm"] = newTypeIdsValue7.value[0];
    }
  }
  if (value1) {
    params["startPrice"] = value1;
    params["endPrice"] = value2;
  } else {
    if (newTypeIdsValue5.value.length != 0) {
      if (newTypeIdsValue5.value.length == 2) {
        params["startPrice"] = newTypeIdsValue5.value[0];
        params["endPrice"] = newTypeIdsValue5.value[1];
      } else {
        params["startPrice"] = newTypeIdsValue5.value[0];
      }
    }
  }

  Axios("get", "/fodder/front/list", params, false, (res) => {
    // console.log(res, '分类')
    if (res.data.rows.length == 0) {
      videoList.value = [];
      loading.close();
    } else {
      let new_srcList = res.data.rows;
      setTimeout(() => {
        videoList.value = new_srcList;
        page.value.total = res.data.total;
        loading.close();
      }, 200);
    }
  });
};
//价格区间
const isDarkTime = function (value1, value2) {
  console.log(1212);

  if (value1 / 1 > value2 / 1 || !value1 || !value2) {
    ElMessage({
      showClose: true,
      message: "设置范围区间有误",
      type: "warning",
    });
  } else {
    init_VIDEO(value1, value2);
  }
};
onMounted(init_VIDEO);

/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init_VIDEO();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init_VIDEO();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init_VIDEO();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init_VIDEO();
};
// 音频详情
const router = useRouter();
let inputTitle = "";

router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("inputTitle")
    ? (inputTitle = router.currentRoute.value.query.inputTitle)
    : ""
  : "";

router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("keyword")
    ? (inputTitle = router.currentRoute.value.query.keyword)
    : ""
  : "";

keyword.value = inputTitle || "";
const goParticulars = function (index) {
  console.log(index.id);
  router.push({
    path: "/ShadowMaterialVideoMusic",
    query: {
      id: index.id,
    },
  });
};
onBeforeUnmount(() => {
  /*
  如果音乐是关闭就不调用
 */
  ShadowMaterialyinyueRef.value.isPlaying.value
    ? ShadowMaterialyinyueRef.value.handleDisplay()
    : "";
});
const collectIds = ref([])
const getCollects = async () => {
  await Axios(
    "get",
    "/fodder/collect/collect-ids",
    {
    },
    false,
    (res) => {
      collectIds.value = res.data.data
    }
  );
}
getCollects();

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(dropDown, {
      onTabClick: tabClick,
      onIsDarkTime: isDarkTime,
      boxRef: boxRef.value
    }, null, 8, ["boxRef"]),
    _createElementVNode("div", null, [
      (videoList.value.length == 0)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (videoList.value.length > 0)
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              gutter: 20
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    span: 12,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(moduleProvideMaterialMusic, {
                        message: index,
                        collectIds: collectIds.value,
                        onCallback: handleCallback,
                        class: "SL_offerMaterialListdiv",
                        ref_for: true,
                        ref_key: "moduleProvideMaterialMusicRef",
                        ref: moduleProvideMaterialMusicRef
                      }, null, 8, ["message", "collectIds"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (videoList.value.length != 0)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            "current-page": _unref(page).pageNum,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).pageNum) = $event)),
            "page-size": _unref(page).pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageSize) = $event)),
            onSizeChange: sizeChange,
            onCurrentChange: currentChange,
            style: {"margin":"0.4rem 0"},
            background: "",
            layout: "prev, pager, next",
            total: _unref(page).total
          }, null, 8, ["current-page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(wavesurfer, _mergeProps({
      ref_key: "ShadowMaterialyinyueRef",
      ref: ShadowMaterialyinyueRef,
      modelValue: isChildVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isChildVisible).value = $event))
    }, bovalue.value, {
      onStop: MusicOff,
      onPlay: MusicOn
    }), null, 16, ["modelValue"])
  ]))
}
}

})